/* tslint:disable */
/* eslint-disable */
/**
 * Easy Templates Internal API
 * This is an internal REST API for Easy Templates application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VariableConfig } from './VariableConfig';
import {
    VariableConfigFromJSON,
    VariableConfigFromJSONTyped,
    VariableConfigToJSON,
} from './VariableConfig';
import type { VariableValue } from './VariableValue';
import {
    VariableValueFromJSON,
    VariableValueFromJSONTyped,
    VariableValueToJSON,
} from './VariableValue';

/**
 * 
 * @export
 * @interface VariableCreateRequest
 */
export interface VariableCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof VariableCreateRequest
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VariableCreateRequest
     */
    required?: boolean;
    /**
     * Label of the variable, used in markup
     * @type {string}
     * @memberof VariableCreateRequest
     */
    label: string;
    /**
     * The type of the variable, specifies both the kind of data a variable can store and what widget is used for its display
     * @type {string}
     * @memberof VariableCreateRequest
     */
    type: VariableCreateRequestTypeEnum;
    /**
     * 
     * @type {VariableValue}
     * @memberof VariableCreateRequest
     */
    defaultValue?: VariableValue;
    /**
     * 
     * @type {VariableConfig}
     * @memberof VariableCreateRequest
     */
    config?: VariableConfig | null;
}


/**
 * @export
 */
export const VariableCreateRequestTypeEnum = {
    Text: 'text',
    Longtext: 'longtext',
    Select: 'select',
    Multiselect: 'multiselect',
    Number: 'number',
    Date: 'date'
} as const;
export type VariableCreateRequestTypeEnum = typeof VariableCreateRequestTypeEnum[keyof typeof VariableCreateRequestTypeEnum];


/**
 * Check if a given object implements the VariableCreateRequest interface.
 */
export function instanceOfVariableCreateRequest(value: object): value is VariableCreateRequest {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function VariableCreateRequestFromJSON(json: any): VariableCreateRequest {
    return VariableCreateRequestFromJSONTyped(json, false);
}

export function VariableCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariableCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'required': json['required'] == null ? undefined : json['required'],
        'label': json['label'],
        'type': json['type'],
        'defaultValue': json['defaultValue'] == null ? undefined : VariableValueFromJSON(json['defaultValue']),
        'config': json['config'] == null ? undefined : VariableConfigFromJSON(json['config']),
    };
}

export function VariableCreateRequestToJSON(value?: VariableCreateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'required': value['required'],
        'label': value['label'],
        'type': value['type'],
        'defaultValue': VariableValueToJSON(value['defaultValue']),
        'config': VariableConfigToJSON(value['config']),
    };
}

